/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccountExperienceTransactionType = {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT'
} as const;
export type AccountExperienceTransactionType = typeof AccountExperienceTransactionType[keyof typeof AccountExperienceTransactionType];


export function instanceOfAccountExperienceTransactionType(value: any): boolean {
    for (const key in AccountExperienceTransactionType) {
        if (Object.prototype.hasOwnProperty.call(AccountExperienceTransactionType, key)) {
            if (AccountExperienceTransactionType[key as keyof typeof AccountExperienceTransactionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountExperienceTransactionTypeFromJSON(json: any): AccountExperienceTransactionType {
    return AccountExperienceTransactionTypeFromJSONTyped(json, false);
}

export function AccountExperienceTransactionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountExperienceTransactionType {
    return json as AccountExperienceTransactionType;
}

export function AccountExperienceTransactionTypeToJSON(value?: AccountExperienceTransactionType | null): any {
    return value as any;
}

export function AccountExperienceTransactionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AccountExperienceTransactionType {
    return value as AccountExperienceTransactionType;
}

